import koTranslation from "./locales/ko.json";
import enTranslation from "./locales/en.json";

export const membershipResources = {
  ko: {
    translation: koTranslation,
  },
  en: {
    translation: enTranslation,
  },
};
